/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import _ from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import ServiceCardDownloader from '../../components/ServiceCardDownloader/ServiceCardDownloader';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import GrayPanel from '../../components/GrayPanel';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import v from './validators';
import loadingData from './loading';
import agentConfig from './agent';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const changeDict = {
  powJezdni: {
    label: 'Powierzchnia zajęcia jezdni [m2]',
    editable: true,
  },
  powChodnika: {
    label: 'Powierzchnia zajęcia chodnika [m2]',
    editable: true,
  },
  powPobocza: {
    label: 'Powierzchnia zajęcia zieleńca - pobocza [m2]',
    editable: true,
  },
  ulica: {
    label: 'Ulica',
    editable: true,
  },
  lokalizacja: {
    label: 'Odcinku zlokalizowany między ulicami',
    editable: true,
    type: 'textarea',
  },
  dataOd: {
    label: 'Zajęcie od dnia',
    editable: true,
  },
  dataDo: {
    label: 'Zajęcie do dnia',
    editable: true,
  },
  cel: {
    label: 'Cel zajęcia',
    editable: true,
    type: 'textarea',
  },
  kierownik: {
    label: 'Kierownik budowy',
    editable: true,
    type: 'textarea',
  },
  telefon: {
    label: 'Telefon',
    editable: true,
  },
};

const urzadzeniaDict = {
  urzadzeniaGlebokosc: {
    label: 'Głębokość [m]',
    editable: true,
  },
  urzadzeniaDlugosc: {
    label: 'Długość urządzenia w pasie drogowym [m]',
    editable: true,
  },
  urzadzeniaSrednica: {
    label: 'Średnica /rzut/ zewnętrzna [m]',
    editable: true,
  },
};

const reklamyDict = {
  reklamyPow: {
    label: 'Powierzchnia reklamy [m2]',
    editable: true,
  },
};


class CzasoweZajeciePasa extends React.Component {
  state = {
    info: {
      powJezdni: null,
      powChodnika: null,
      powPobocza: null,
      ulica: null,
      lokalizacja: null,
      dataOd: null,
      dataDo: null,
      cel: null,
      kierownik: null,
      telefon: null,
      urzadzeniaGlebokosc: null,
      urzadzeniaDlugosc: null,
      urzadzeniaSrednica: null,
      reklamyPow: null,
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    eserviceDistrict: null,
    loading: false,
  };

  validators = {
    powJezdni: [v.NotNull, v.isNumber],
    powChodnika: [v.NotNull, v.isNumber],
    powPobocza: [v.NotNull, v.isNumber],
    ulica: [v.NotNull],
    lokalizacja: [v.NotNull],
    dataOd: [v.NotNull],
    dataDo: [v.NotNull],
    cel: [v.NotNull],
    kierownik: [v.NotNull],
    telefon: [v.NotNull],
    urzadzeniaGlebokosc: [v.NotNull, v.isNumber],
    urzadzeniaDlugosc: [v.NotNull, v.isNumber],
    urzadzeniaSrednica: [v.NotNull, v.isNumber],
    reklamyPow: [v.NotNull, v.isNumber],
  };

  nextStep = '/eservices/eserviceSummary/';

  onHide = () => this.setState({ showError: false });

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  insertTestData = () => {
    this.setState({
      info: {
        miejscowosc: 'Olesno',
        ulica: 'Testowa',
        uzasadnienie: 'Uzasadnienie testowe',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.redirectToSummary(resp.jobId);
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ fontWeight: 'bold' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        <DecisionContainer
          title={'1. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={changeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <DecisionContainer
          title={'2. Umieszczenie w pasie drogowym urządzeń nie związanych z funkcjonowaniem drogi'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={urzadzeniaDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <DecisionContainer
          title={'3. Umieszczenie w pasie drogowym reklam'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={reklamyDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />

        <GrayPanel title={"Informacja dla wnioskodawcy"}>
          <div className="row">
            <div className="col-sm-12">
              <p>Opłata za czasowe zajęcie pasa drogowego wynika z decyzji i jest obliczana  zgodnie z Uchwałą Nr XXV/214/04 Rady Miejskiej w Oleśnie z dnia 24 listopada 2004 r. w sprawie ustalenia wysokości stawek opłat za zajęcie pasa drogowego ze zm.</p>
              <p>- Opłatę za zajęcie pasa drogowego, ustala się jako iloczyn liczby metrów kwadratowych zajętej powierzchni pasa drogowego, stawki opłaty za zajęcie 1m2 pasa drogowego i liczby dni zajmowania pasa drogowego.</p>
              <p>- Opłatę za zajęcie pasa drogowego w celu, umieszczenia w nim urządzenia, ustala się jako iloczyn liczby metrów kwadratowych powierzchni pasa drogowego zajętej przez rzut poziomy urządzenia i stawki opłaty za zajęcie 1m2 pasa drogowego pobieranej za każdy rok umieszczenia urządzenia w pasie drogowym, przy czym za umieszczenie urządzenia w pasie drogowym lub na drogowym obiekcie inżynierskim przez okres krótszy niż rok opłata obliczana jest proporcjonalnie do liczby dni umieszczenia urządzenia w pasie drogowym lub na drogowym obiekcie inżynierskim.</p>
              <br />
              <p><b>Do niniejszego wniosku należy dołączyć załączniki:</b></p>
              <p>1. Zatwierdzony przez Starostwo Powiatowe projekt organizacji ruchu na czas prowadzenia robót w pasie drogowym.</p>
              <p>2. Mapa zasadnicza z naniesionym obiektem budowlanym lub innym</p>

            </div>
          </div>
        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            {this.props.prefix === 'gmina_olesno_powiat_oleski' ?
              <ServiceCardDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
              : null}
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

CzasoweZajeciePasa.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(CzasoweZajeciePasa),
);



// WEBPACK FOOTER //
// src/routes/eservices/CzasoweZajeciePasa.js